import * as yup from 'yup'

export type FormData = {
  [key in FORM_FIELDS]: string
}

export const enum FORM_FIELDS {
  INDICATION = 'indication',
  CAPBRAND = 'capbrand',
  availspace_CERVICAL = 'availspace_CERVICAL',
  availspace_MIDDLE = 'availspace_MIDDLE',
  availspace_INCISAL = 'availspace_INCISAL',
  PREPARATION_COLOR_MIDDLE = 'prepcolor_middle',
  PREPARATION_COLOR_CERVICAL = 'prepcolor_cervical',
  PREPARATION_COLOR_INCISAL = 'prepcolor_incisal',
  TARGET_COLOR_VALUE_MIDDLE = 'targetcolor_middle_value',
  TARGET_COLOR_VALUE_CERVICAL = 'targetcolor_cervical_value',
  TARGET_COLOR_VALUE_INCISAL = 'targetcolor_incisal_value',
}

const baseSchema = {
  [FORM_FIELDS.INDICATION]: yup.string().required(`Indication is required`),
  [FORM_FIELDS.CAPBRAND]: yup.string().required(`Framework is required`),
}

export const validationSchema = yup.object().shape({
  ...baseSchema,
})
